import {match} from 'ts-pattern';

import {head} from 'ramda';
import {isArray} from 'ramda-adjunct';

import {warehouseRoutes} from '@dms/routes';
import {DmsDataGrid, catchUnhandledDataGridActions} from '@dms/shared';
import {FullscreenDataGridWrapper} from '@dms/warehouse/shared-components';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export function IssueNotes() {
  const navigate = useNavigate();

  const actionCallback: ActionCallback = ({actionKey, rowId, sourceSearchParams}) => {
    const issueNoteId = isArray(rowId) ? head(rowId) : rowId;

    match(actionKey)
      .with('redirectDetail', 'details', () =>
        navigate(
          composePath(warehouseRoutes.issueNoteDetailOverview, {
            queryParams: sourceSearchParams,
            params: {id: issueNoteId},
            isSearchParamsPreserved: false,
          })
        )
      )
      .otherwise(() => catchUnhandledDataGridActions(actionKey));
  };

  return (
    <FullscreenDataGridWrapper hideCardWrapper>
      <DmsDataGrid
        gridCode="issue-notes-list"
        actionCallback={actionCallback}
        data-testid="issue-notes-list"
      />
    </FullscreenDataGridWrapper>
  );
}
